declare var window: any;
const configFunc = {
  HttpEndpoint: (path: any) => `${window.SCHEMA}://${window.ENDPOINT}${path}`,
  DevHttpEndpoint: (path: any) => `${window.DEVSCHEMA}://${window.DEVENDPOINT}${path}`,
};

export default configFunc;